import {
  formatEventDateTime,
  getPublicApiBaseUrl,
  mapApiEventToCard,
} from './publicEventsApi';

async function parseJsonResponse(res) {
  const text = await res.text();
  let json = null;
  try {
    json = text ? JSON.parse(text) : null;
  } catch {
    json = null;
  }
  if (!res.ok) {
    const msg =
      (json && (json.message || json.error)) || res.statusText || 'Erreur API';
    throw new Error(typeof msg === 'string' ? msg : JSON.stringify(msg));
  }
  return json;
}

export async function fetchHomeContent() {
  const base = getPublicApiBaseUrl();
  const json = await parseJsonResponse(await fetch(`${base}/home-content`));
  const payload = json?.data;
  if (
    payload &&
    typeof payload === 'object' &&
    !Array.isArray(payload) &&
    payload.data &&
    typeof payload.data === 'object'
  ) {
    return payload.data;
  }
  return payload || null;
}

export function mapScheduleItemsToCards(items = [], categories = []) {
  return (items || []).map((e) => mapApiEventToCard(e, categories));
}

export function formatBannerEventDate(iso) {
  const { time, date } = formatEventDateTime(iso);
  return [time, date].filter(Boolean).join(' ');
}
